import React, { useState } from 'react';
import { Link } from 'gatsby';
import { useCartCount } from 'gatsby-theme-shopify-manager';
import { nanoid } from 'nanoid';

import { mainNavigation, socialLinks } from '../data';
import { Logo, BagIcon } from './vectors';
import { MobileMenu } from './mobile-menu';
import { SearchModal } from './search-modal';

function Header() {
  const [isOpen, setIsOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const cartCount = useCartCount();
  return (
    <article className="sticky top-0 z-20 bg-white">
      <div className="w-full px-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
        <nav className="items-center justify-end hidden pt-4 space-x-8 lg:flex">
          <button
            type="button"
            onClick={() => setIsModalOpen(true)}
            className="text-sm tracking-wider uppercase transition duration-150 ease-in-out text-dark-pink hover:underline hover:text-light-pink focus:underline focus:text-light-pink focus:shadow-none"
          >
            Search
          </button>
          {mainNavigation.pages.map((page) => (
            <Link
              key={nanoid()}
              to={page.slug}
              className="text-sm tracking-wider uppercase transition duration-150 ease-in-out text-dark-pink hover:underline hover:text-light-pink focus:underline focus:text-light-pink focus:shadow-none"
            >
              {page.label}
            </Link>
          ))}
          {socialLinks.map((node) => (
            <a
              key={nanoid()}
              href={node.url}
              className="transition duration-150 ease-in-out hover:text-light-pink focus:text-light-pink focus:shadow-none"
            >
              <span className="sr-only">{node.label}</span>
              <node.icon className="w-6 h-6" />
            </a>
          ))}
        </nav>
        <nav className="grid-cols-12 lg:grid">
          <div className="flex items-center justify-between col-span-10 col-start-2 lg:items-end lg:justify-center">
            <Link
              to="/"
              className="flex items-center flex-shrink-0 py-4 transition duration-150 ease-in-out text-dark-pink lg:order-2 lg:ml-8 hover:text-light-pink focus:text-light-pink focus:shadow-none"
            >
              <Logo className="h-10 fill-current lg:h-20" />
            </Link>
            {mainNavigation.collections.map((node, index) => (
              <Link
                key={nanoid()}
                to={node.slug}
                partiallyActive={node.slug !== '/'}
                activeClassName="text-light-pink border-dark-pink"
                className={`items-center hidden    px-1 py-3 font-normal leading-none tracking-wider uppercase transition duration-150 ease-in-out border-b-2 border-transparent text-dark-pink lg:inline-flex hover:text-light-pink focus:text-light-pink hover:border-dark-pink focus:border-dark-pink focus:shadow-none ${
                  index === 0 ? 'ml-0' : 'ml-8'
                } ${index < 3 ? 'order-1' : 'order-3'}`}
              >
                {node.label}
              </Link>
            ))}
            <div className="flex items-center -mr-2 lg:hidden">
              {/* Mobile menu button */}
              <button
                type="button"
                onClick={() => setIsOpen((prevState) => !prevState)}
                aria-label="Main menu"
                aria-expanded="false"
                className="inline-flex items-center justify-center p-2 transition duration-150 ease-in-out rounded-md hover:bg-gray-100 focus:outline-none focus:bg-gray-100"
              >
                {isOpen ? (
                  <svg
                    className="block w-6 h-6"
                    stroke="currentColor"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                ) : (
                  <svg
                    className="block w-6 h-6"
                    stroke="currentColor"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M4 6h16M4 12h16M4 18h16"
                    />
                  </svg>
                )}
              </button>
            </div>
          </div>
          <div className="items-end justify-end hidden py-2 lg:flex">
            <Link
              to="/cart/"
              className="relative p-2 -mr-2 transition duration-150 ease-in-out rounded-md focus:shadow-none focus:bg-gray-100"
            >
              <BagIcon className="w-6" />
              <div className="absolute inset-0 flex items-center justify-center text-xs transform translate-y-0.5 tabular-nums">
                {cartCount}
              </div>
            </Link>
          </div>
          <SearchModal
            isModalOpen={isModalOpen}
            setIsModalOpen={setIsModalOpen}
          />
          <MobileMenu isOpen={isOpen} setIsOpen={setIsOpen} />
        </nav>
      </div>
    </article>
  );
}

export { Header };
